import React from 'react'
import {
  Modal,
  Typography,
  IconButton,
  TextField,
  Button,
  AppBar,
  Tab,
  Tabs,
  Table,
  TableCell,
  TableBody,
  TableRow,
  Checkbox,
} from '@material-ui/core'
import './ReservationApprovalManager.scss'

import CloseIcon from '@material-ui/icons/Close'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import {UsersContext} from '../../context/Users'
import LoadingIndicator from '../ReservationConfiguration/LoadingIcon'
import useStateDebounce from './useStateDebounce'

const RootClass = 'reservation-approval-manager'

const ReservationApprovalManager = ({
  open = false,
  managerIds = [],
  managerTemplateIds = [],
  onClose = () => {},
  onSave = () => {},
}) => {
  const [firstLoad, setFirstLoad] = React.useState(true)
  const [curTabIndex, setCurTabIndex] = React.useState(0)
  const {users, userTemplates, getAllUsers, getAllUserTemplates} = React.useContext(UsersContext)

  const [selectedUsers, setSelectedUsers] = React.useState([])
  const [selectedUserTemplates, setSelectedUserTemplates] = React.useState(managerTemplateIds)
  const [searchText, setSearchText, realSearchText] = useStateDebounce('', 500)
  const refSearchText = React.useRef(null)

  const handleToggleUser = id => {
    const index = selectedUsers.indexOf(id)
    if (index !== -1) {
      selectedUsers.splice(index, 1)
      // unselect user templates with these users
      for (let i = selectedUserTemplates.length - 1; i >= 0; i--) {
        const ut = userTemplates.templates.find(e => e.template_id === selectedUserTemplates[i])
        if (!ut) continue // skip
        const us = ut.template_users.find(u => u.id === id)
        if (us) {
          selectedUserTemplates.splice(i, 1)
        }
      }
    } else {
      selectedUsers.push(id)
    }
    setSelectedUsers([...selectedUsers])
  }

  const handleToggleUserTemplate = id => {
    const index = selectedUserTemplates.indexOf(id)
    if (index !== -1) {
      selectedUserTemplates.splice(index, 1)
      // remove selected users
      userTemplates.templates
        .find(e => e.template_id === id)
        .template_users.forEach(e => {
          const suidx = selectedUsers.indexOf(e.id)
          if (suidx !== -1) {
            selectedUsers.splice(suidx, 1)
          }
        })
    } else {
      selectedUserTemplates.push(id)
      // add selected users
      userTemplates.templates
        .find(e => e.template_id === id)
        .template_users.forEach(e => {
          if (selectedUsers.indexOf(e.id) === -1) {
            selectedUsers.push(e.id)
          }
        })
    }
    setSelectedUserTemplates([...selectedUserTemplates])
  }

  const handleChange = (event, newValue) => {
    setCurTabIndex(newValue)
  }

  const handleChangeSearch = (e, value) => {
    setSearchText(value)
  }
  React.useEffect(() => {
    if (open && firstLoad) {
      setFirstLoad(false)
    }
  }, [open, firstLoad, setFirstLoad])

  React.useEffect(() => {
    if (!firstLoad) {
      if (curTabIndex === 0) {
        getAllUsers({search: searchText})
      } else if (curTabIndex === 1) {
        getAllUserTemplates({query: searchText})
      }
    }
  }, [firstLoad, searchText, curTabIndex, getAllUsers, getAllUserTemplates])

  React.useEffect(() => {
    if (open) {
      if (managerIds.length === 0) {
        setSelectedUsers([parseInt(localStorage.getItem('user_id'))])
      } else {
        setSelectedUsers([...managerIds])
      }
      setSelectedUserTemplates([...managerTemplateIds])
    }
  }, [open, managerIds, setSelectedUsers, managerTemplateIds, setSelectedUserTemplates])

  return (
    <Modal
      style={{position: 'absolute'}}
      open={open}
      onClose={onClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <div className={`c-res-mod ap-modal ${RootClass}`}>
        <div className="ap-modal__header">
          <Typography className="ap-modal__title">Select Approval Managers</Typography>
          <Typography className="ap-modal__sub-title">
            Reservations will be sent to approval managers for confirmation.
          </Typography>
          <IconButton onClick={onClose} className="ap-modal__btn-x">
            <CloseIcon />
          </IconButton>
        </div>
        <div className="ap-modal__body">
          <div className={`ap-flexbox  ${RootClass}__search-container`}>
            <TextField
              variant="outlined"
              fullWidth
              className={`ap-textfield  ${RootClass}__search-input`}
              label={curTabIndex === 0 ? 'Enter Name or Email Address' : 'Enter Template Name'}
              placeholder={
                curTabIndex === 0 ? 'Enter Name or Email Address' : 'Enter Template Name'
              }
              value={realSearchText}
              onChange={e => handleChangeSearch(e, e.target.value)}
              inputRef={refSearchText}
            />
            {!!searchText && (
              <IconButton
                size="small"
                className={`${RootClass}__search-close-button`}
                onClick={e => handleChangeSearch(e, '')}
              >
                <CloseIcon />
              </IconButton>
            )}
          </div>
          <div className={`ap-flexbox ap-flexbox--column ${RootClass}__tab-container`}>
            <div className="ap-tab">
              <Tabs
                value={curTabIndex}
                onChange={handleChange}
                className="ap-tab__tabs"
                aria-label="simple tabs example"
              >
                <Tab
                  label={`Current Users ${
                    selectedUsers.length > 0 ? `(${selectedUsers.length})` : ''
                  }`}
                  id="wrapped-tab-0"
                  aria-controls="wrapped-tabpanel-0"
                  className={`ap-tab__tab-item`}
                />
                <Tab
                  label={`Users Templates ${
                    selectedUserTemplates.length > 0 ? `(${selectedUserTemplates.length})` : ''
                  }`}
                  id="wrapped-tab-1"
                  aria-controls="wrapped-tabpanel-1"
                  className={`ap-tab__tab-item`}
                />
              </Tabs>
            </div>
            <div className={`${RootClass}__tab-body-wrapper`}>
              <div
                className={`${RootClass}__table-wrapper ap-flexbox ap-flexbox--column ap-scrollbar`}
                hidden={curTabIndex !== 0}
              >
                {users.isLoading && <LoadingIndicator style={{width: '100%'}} />}
                <Table fullWidth aria-label="simple table" className="ap-table">
                  <TableBody>
                    {!users.isLoading && users.users.length === 0 && (
                      <TableRow>
                        <TableCell align="center" className="ap-typography ap-typography--sm">
                          No results found
                        </TableCell>
                      </TableRow>
                    )}
                    {users.users.map(user => {
                      if (user.is_active) {
                        return (
                          <TableRow key={user.id} onClick={() => handleToggleUser(user.id)}>
                            <TableCell scope="row">
                              <Checkbox
                                size="small"
                                checkedIcon={<CheckCircleIcon style={{color: '#3473ff'}} />}
                                checked={selectedUsers.indexOf(user.id) !== -1}
                              />
                            </TableCell>
                            <TableCell align="left" className="ap-typography ap-typography--sm">
                              {user.first_name} {user.last_name}
                            </TableCell>
                            <TableCell
                              align="left"
                              className="ap-typography ap-typography--sm ap-typography--gray"
                            >
                              {user.email}
                            </TableCell>
                          </TableRow>
                        )
                      }
                      return null
                    })}
                  </TableBody>
                </Table>
              </div>
              <div
                className={`${RootClass}__table-wrapper ap-flexbox ap-flexbox--column ap-scrollbar`}
                hidden={curTabIndex !== 1}
              >
                {userTemplates.isLoading && <LoadingIndicator style={{width: '100%'}} />}
                <Table fullWidth aria-label="simple table" className="ap-table">
                  <TableBody>
                    {!userTemplates.isLoading && userTemplates.templates.length === 0 && (
                      <TableRow>
                        <TableCell align="center" className="ap-typography ap-typography--sm">
                          No results found
                        </TableCell>
                      </TableRow>
                    )}
                    {userTemplates.templates.map(template => (
                      <TableRow
                        key={template.template_id}
                        onClick={() => handleToggleUserTemplate(template.template_id)}
                      >
                        <TableCell scope="row">
                          <Checkbox
                            size="small"
                            checkedIcon={<CheckCircleIcon style={{color: '#3473ff'}} />}
                            checked={selectedUserTemplates.indexOf(template.template_id) !== -1}
                          />
                        </TableCell>
                        <TableCell align="left" className="ap-typography ap-typography--sm">
                          {template.template_name}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
            </div>
          </div>
        </div>
        <div className="ap-modal__footer">
          <div className="ap-modal__container ap-modal__container--right">
            <Button
              onClick={e => onSave(e, selectedUsers, selectedUserTemplates)}
              style={{width: 96}}
              className="ap-button ap-button--primary"
            >
              Apply
            </Button>
            <Button onClick={onClose} style={{width: 96}} className="ap-button ap-button--outlined">
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  )
}
export default ReservationApprovalManager
